import { useState,useEffect } from 'react'
import './styles/UsersAdmin.css'
import Action from '../Action'
import { useFetch } from '../../hooks/useFetch'
import { useFetchPost } from '../../hooks/useFetchPost'
import Selector from '../Selector'
import LoadAdding from '../LoadAdding'
import LoadSimple from '../LoadSimple'
import UserList from './UserList'
import ModalDeleteRol from './ModalDeleteRol'
import Modal from 'react-modal';
import { capitalizeFirstLetter } from '../../utils/utils'
import { lang } from '../generales/traduction'
const deleteUserModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#ffffff !important',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'30%',
      height:'20%',
      padding:'20px'
    },
  };
const TableRoles=(props)=>{
  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  function openDeleteUserModal() {
      setDeleteUserModalOpen(true);
    }

  function closDeleteUserModal() {
    setDeleteUserModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  return (
      <>
      <div className='cont-table-portafolio ' >
                                  <div className={"head-table-portafolio"+props.mode}>
                                  <div className="compact-head-table-portafolio">
                                      <div className='field-head-table-users field-nombre' style={{width:'30%'}}>
                                          Rol
                                      </div>
                                      { (props.dataPermisos.loading)?<div style={{width:'100%',height:'95%',display:'flex',justifyContent:'center'}}><LoadSimple></LoadSimple></div>:
                                              props.dataPermisos.data.data.map((element,index)=>(
                                                  <div className='field-head-table-users field-nombre' style={{width:'20%', display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center'}}>
                                          {element.module_name}
                                      </div>
                                          ))}
                                           <div className='field-head-table-users field-nombre' style={{width:'20%'}}>
                                          {capitalizeFirstLetter(lang[props.languaje]['acciones'])}
                                      </div>
                                      </div>
                                  </div>
                                  <div className='body-table-users'>
                                  <div className='cont-row-user-list'>
                                  { (props.dataRoles.loading)?<div style={{width:'100%',height:'95%',display:'flex',justifyContent:'center'}}><LoadSimple></LoadSimple></div>:
                                              props.dataList.map((element,index)=>(
                                                  <div className={"row-table-portafolio"+props.mode} key={index} onClick={()=>props.SelectRol(element.rol_id)}>
                                                  <div className='field-body-table-users field-nombre' style={{width:'30%',textAlign: 'center',borderRight:'solid 1px #d5d5d5'}}>
                                                    {element.name}
                                                  </div>
                                                  {(props.dataPermisos.loading)?<div style={{width:'100%',height:'95%',display:'flex',justifyContent:'center'}}><LoadSimple></LoadSimple></div>:props.dataPermisos.data.data.map((permiso,index)=>(
                                                  <div className='field-body-table-users field-correo' style={{width:'20%',fontWeight:'bold',borderRight:'solid 1px #d5d5d5'}}>
                                                  {
                                                  (element.permissions.some(objeto => objeto.permission_id === permiso.permission_id))?'X':''
                                                  }
                                                  </div>
                                          ))}
                                          <div className='field-body-table-users field-acciones'>
              <div className='cont-img-field-acciones' style={{height:'60%'}}>
                <img className='img-field-acciones' src='/iconos/editar.png' title='Editar' name='Editar' user_id={element.rol_id} onClick={() => props.handleChangEdit(element)} />
              </div>
              <div className='cont-img-field-acciones'  style={{height:'60%'}}>
                <img className='img-field-acciones' src='/iconos/delete.png' title='Eliminar'name='Eliminar' user_id={element.rol_id} onClick={(e)=> {e.stopPropagation();handledeleteUserClick(element)}}/>
              </div>
            </div>
                                          {/* <div className='field-body-table-users field-correo' style={{width:'20%',fontWeight:'bold'}}>
                                          <img className='img-field-acciones' src='/iconos/delete.png' title='Eliminar'name='Eliminar' rol_id={element.rol_1} onClick={(e)=> {e.stopPropagation();props.handledeleteRolClick(element.rol_id)}} />
                                                  </div> */}
                                                  
                                                </div>   
                                          ))}
      
          
         
      
      
    </div>
                                      
                                  </div>
                              </div>
       
                              <Modal
      isOpen={deleteUserModalOpen}
      // isOpen={true}
      // onAfterOpen={afterOpenExeption}
      onRequestClose={closDeleteUserModal}
      style={deleteUserModalStyles}
      contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalDeleteRol languaje={props.languaje}  mode={props.mode} server={props.server} setData={props.setData} setLoading={props.setLoading} setError={props.setError} getRoles={props.getRoles} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteRol>
  </Modal>
                              
                              </>
  )
}

export default TableRoles